import { z } from 'zod';
export const CalendarEventTypeSchema = z.enum([
    'REUNION_CLIENTE',
    'REUNION_INTERNA',
    'LLAMADA',
    'DEMO',
    'KICKOFF',
    'ENTREGA',
    'SEGUIMIENTO',
    'HITO_PAGO',
    'OTRO',
]);
export const CalendarEventTypeLabel = {
    REUNION_CLIENTE: 'Reunión con cliente',
    REUNION_INTERNA: 'Reunión interna',
    LLAMADA: 'Llamada',
    DEMO: 'Demo',
    KICKOFF: 'Kickoff',
    ENTREGA: 'Entrega',
    SEGUIMIENTO: 'Seguimiento',
    HITO_PAGO: 'Hito de pago',
    OTRO: 'Otro',
};
// Color por tipo — clases Tailwind para la UI.
export const CalendarEventTypeColor = {
    REUNION_CLIENTE: {
        bg: 'bg-purple-500/15',
        text: 'text-purple-200',
        border: 'border-purple-500/30',
        dot: 'bg-purple-400',
    },
    REUNION_INTERNA: {
        bg: 'bg-blue-500/15',
        text: 'text-blue-200',
        border: 'border-blue-500/30',
        dot: 'bg-blue-400',
    },
    LLAMADA: {
        bg: 'bg-emerald-500/15',
        text: 'text-emerald-200',
        border: 'border-emerald-500/30',
        dot: 'bg-emerald-400',
    },
    DEMO: {
        bg: 'bg-rose-500/15',
        text: 'text-rose-200',
        border: 'border-rose-500/30',
        dot: 'bg-rose-400',
    },
    KICKOFF: {
        bg: 'bg-indigo-500/15',
        text: 'text-indigo-200',
        border: 'border-indigo-500/30',
        dot: 'bg-indigo-400',
    },
    ENTREGA: {
        bg: 'bg-cyan-500/15',
        text: 'text-cyan-200',
        border: 'border-cyan-500/30',
        dot: 'bg-cyan-400',
    },
    SEGUIMIENTO: {
        bg: 'bg-amber-500/15',
        text: 'text-amber-200',
        border: 'border-amber-500/30',
        dot: 'bg-amber-400',
    },
    HITO_PAGO: {
        bg: 'bg-teal-500/15',
        text: 'text-teal-200',
        border: 'border-teal-500/30',
        dot: 'bg-teal-400',
    },
    OTRO: {
        bg: 'bg-slate-500/15',
        text: 'text-slate-200',
        border: 'border-slate-500/30',
        dot: 'bg-slate-400',
    },
};
const dateTimeOrIso = z.string().refine((v) => !Number.isNaN(Date.parse(v)), 'Fecha no válida');
export const CreateCalendarEventSchema = z
    .object({
    title: z.string().min(2).max(300),
    description: z.string().max(5000).nullable().optional(),
    type: CalendarEventTypeSchema.default('OTRO'),
    startAt: dateTimeOrIso,
    endAt: dateTimeOrIso.nullable().optional(),
    allDay: z.boolean().default(false),
    location: z.string().max(300).nullable().optional(),
    isPrivate: z.boolean().default(false),
    reminderMinutesBefore: z.coerce.number().int().min(0).max(10080).nullable().optional(),
    opportunityId: z.string().nullable().optional(),
    attendeeIds: z.array(z.string()).max(50).default([]),
})
    .superRefine((data, ctx) => {
    if (data.endAt) {
        const start = new Date(data.startAt).getTime();
        const end = new Date(data.endAt).getTime();
        if (end <= start) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['endAt'],
                message: 'La hora de fin debe ser posterior al inicio',
            });
        }
    }
});
export const UpdateCalendarEventSchema = CreateCalendarEventSchema.innerType().partial();
export const AttendeeDtoSchema = z.object({
    userId: z.string(),
    userFullName: z.string(),
});
export const CalendarEventDtoSchema = z.object({
    id: z.string(),
    title: z.string(),
    description: z.string().nullable(),
    type: CalendarEventTypeSchema,
    startAt: z.string().datetime(),
    endAt: z.string().datetime().nullable(),
    allDay: z.boolean(),
    location: z.string().nullable(),
    isPrivate: z.boolean(),
    reminderMinutesBefore: z.number().int().nullable(),
    opportunityId: z.string().nullable(),
    opportunityCode: z.string().nullable(),
    opportunityTitle: z.string().nullable(),
    ownerId: z.string(),
    ownerName: z.string(),
    attendees: z.array(AttendeeDtoSchema),
    isObscured: z.boolean(), // si el evento es privado y el usuario no puede ver detalles
    canEdit: z.boolean(),
});
export const CalendarListQuerySchema = z.object({
    from: dateTimeOrIso,
    to: dateTimeOrIso,
    ownerId: z.string().optional(),
    opportunityId: z.string().optional(),
    type: CalendarEventTypeSchema.optional(),
});
export const CalendarListResponseSchema = z.object({
    items: z.array(CalendarEventDtoSchema),
});
//# sourceMappingURL=calendar.js.map